import clsx from 'clsx';
import { memo } from 'react';

import baseStyle from './LabelDefaults.module.css';
import fontStyle from './LabelFontVariant.module.css';
import sizeStyle from './LabelSize.module.css';
import variantStyle from './LabelVariant.module.css';
import weightStyle from './LabelWeight.module.css';

import type { LabelProps } from './Label.types';

function LabelComponent({
  ariaLevel,
  children,
  className,
  fontVariant = 'normal',
  size = 'md',
  variant = 'text',
  weight = 'normal',
  ...rest
}: LabelProps) {
  const spanProps = { ...rest };
  delete spanProps.role;
  delete spanProps['aria-level'];

  const headingProps =
    variant === 'heading'
      ? {
          'aria-level': ariaLevel ?? 2,
          role: 'heading',
        }
      : {};

  return (
    <span
      {...spanProps}
      {...headingProps}
      className={clsx(
        baseStyle.label,
        sizeStyle[size],
        weightStyle[weight],
        variantStyle[variant],
        fontStyle[fontVariant],
        className
      )}
    >
      {children}
    </span>
  );
}

export const Label = memo(LabelComponent);
